const apiConfig = {
  baseUrl: "https://api.themoviedb.org/3/",
  apiKey: "6ae35f9e176e301045aad879786098cf",
  originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
  w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`,
};

export default apiConfig;